
import { Component, Directive, Input } from "@angular/core";
import { NavController } from 'ionic-angular';

import { FoodInventoryPage } from '../../pages/food/food-inventory';
import { MealPage } from '../../pages/food/meal';
import { SupplementPage } from '../../pages/food/supplement'
import { FoodPlanPage } from '../../pages/food/food-plan';

@Component({
  selector: 'food-tabs',
  templateUrl: 'food-tabs.html',
})
@Directive({
  selector: "food-tabs"
})
export class FoodTabs {
  @Input('page') page: string;

  constructor(
    private navCtrl: NavController) {
  }

  doOpenPage() {
    switch(this.page) {
      case 'inventory':
        this.navCtrl.setRoot(FoodInventoryPage);
        break;
      case 'food-plans':
        this.navCtrl.setRoot(FoodPlanPage);
        break;
      case 'meals':
        this.navCtrl.setRoot(MealPage);
        break;
      case 'supplements':
        this.navCtrl.setRoot(SupplementPage);
        break;
    }
  }

}


// WEBPACK FOOTER //
// ./src/components/food-tabs/food-tabs.ts